import { render, staticRenderFns } from "./DashboardLogisticOperator.vue?vue&type=template&id=4b8ad16a&scoped=true&"
import script from "./DashboardLogisticOperator.vue?vue&type=script&lang=js&"
export * from "./DashboardLogisticOperator.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLogisticOperator.vue?vue&type=style&index=0&id=4b8ad16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ad16a",
  null
  
)

export default component.exports